<template>
    <div class="section gallery">
        <div class="gallery--intro rich-text" v-html="content.text"></div>
        <div class="gallery--widget">
            <p class="gallery--empty-message" v-if="!hasImages" v-text="content.no_images_message"></p>

            <div class="gallery--preview" v-if="!isMobile && hasImages">
                <component :is="previewComponent.type"
                        facet="preview"
                        :plugin="previewComponent"
                        :preload="true"
                        resource-name="image"
                        @image-clicked="onOverlayRequested">
                </component>
            </div>
            <div class="gallery--carousel" v-if="hasImages">
                <cmp-carousel :items="carouselSlides"
                        facet="gallery"
                        :show-arrows="true"
                        :show-pagination="false"
                        :show-item-count="isMobile"
                        :passive-mode="true"
                        :idx="slideIdx"
                        @request-change="updateSlideIdx($event)">
                    <template slot="item" slot-scope="props">
                        <div class="gallery--carousel-item grid"
                                :data-images-per-slide="imagesPerSlide">
                            <div class="grid--row gallery--carousel-item-row">
                                <div v-for="(plugin, pluginIdx) in props.item"
                                        class="grid--col gallery--carousel-item-col">
                                    <component :is="plugin.type"
                                            :plugin="plugin"
                                            :preload="plugin.preload"
                                            :resource-name="previewResourceName"
                                            @image-clicked="onImageSelected(props.itemIdx, pluginIdx)">
                                    </component>
                                </div>
                            </div>
                        </div>
                    </template>
                </cmp-carousel>
            </div>
        </div>
    </div>
</template>

<script>
    import { chunk, clamp, cloneDeep } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    const IMAGES_PER_SLIDE_CONFIG = [1, 1, 4, 4, 6, 8];
    const INITIAL_DATA = {
        preview: {
            slideIdx: 0,
            imageIdx: 0,
        },
        state: {
            slideIdx: 0,
            imageIdx: 0,
        },
    };


    export default {
        mixins: [
            cmsPlugin,
        ],
        data() {
            return cloneDeep(INITIAL_DATA);
        },
        computed: {
            ...mapGetters(['viewport']),
            previewResourceName() {
                return this.isMobile ? 'image' : 'thumb';
            },
            slideIdx: {
                get() {
                    if (!this.hasImages) {
                        return 0;
                    }

                    const sanitizedIdx = clamp(this.state.slideIdx, 0, this.carouselSlides.length - 1);
                    this.carouselSlides[sanitizedIdx].forEach(plugin => {
                        this.$set(plugin, 'preload', true);
                    });

                    return sanitizedIdx;
                },
                set(val) {
                    this.state.slideIdx = val;
                },
            },
            imagesPerSlide() {
                const sanitizedMqIdx = toNumeral(this.viewport.mq.query) - 1;
                return IMAGES_PER_SLIDE_CONFIG[clamp(sanitizedMqIdx, 0, IMAGES_PER_SLIDE_CONFIG.length - 1)];
            },
            carouselSlides() {
                return chunk(cloneDeep(this.plugins), this.imagesPerSlide);
            },
            previewComponent() {
                const { slideIdx, imageIdx } = this.preview;
                return (this.hasImages ? this.carouselSlides[slideIdx][imageIdx] : null);
            },
            hasImages() {
                return Array.isArray(this.plugins) && this.plugins.length;
            },
            isMobile() {
                return toNumeral(this.viewport.mq.query) < numerals.MD;
            },
        },
        methods: {
            ...mapActions(['openOverlay']),
            updateSlideIdx(val) {
                this.slideIdx = val;
            },
            onImageSelected(slideIdx, imageIdx) {
                this.state.imageIdx = imageIdx;
                this.preview = { slideIdx, imageIdx };
            },
            onOverlayRequested() {
                const { slideIdx, imageIdx } = this.preview;

                this.openOverlay({
                    component: 'cmp-gallery-overlay',
                    props: {
                        idx: ((slideIdx * this.imagesPerSlide) + imageIdx),
                        plugins: this.plugins,
                    },
                });
            },
        },
        watch: {
            $route() {
                // TODO: Here we should set a loading state instead of already resetting
                Object.assign(this.$data, cloneDeep(INITIAL_DATA));
            },
            content: {
                handler() {
                    // TODO: Reset to `INITIAL_DATA`
                    // Object.assign(this.$data, cloneDeep(INITIAL_DATA));
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?48216dba